import { render, staticRenderFns } from "./PasswordRecover.vue?vue&type=template&id=0a420e96&scoped=true"
import script from "./PasswordRecover.vue?vue&type=script&lang=js"
export * from "./PasswordRecover.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecover.vue?vue&type=style&index=0&id=0a420e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a420e96",
  null
  
)

export default component.exports